export const formatAmount = (amount, decimal = 2) => {
  amount = isNaN(amount) ? 0 : amount
  return amount.toLocaleString(undefined, { minimumFractionDigits: decimal })
}